// 단일 생성에 올린 "여러 학생이 담긴 파일"(행동발달·창체)을 다중 생성 입력으로 넘긴다.
// 원본 파일명은 넘기지 않는다 — 다중 생성 기록에는 학생 수만 남는다.

export const MULTI_STUDENT_BATCH_CATEGORIES = ['행동발달', '창체'];

export const buildFileStudentText = (item = {}) => {
  let text = item.records ? String(item.records) : '';
  if (item.traits) {
    text += text ? `\n\n특성: ${item.traits}` : String(item.traits);
  }
  if (item.individual_traits) {
    text += text ? `, ${item.individual_traits}` : String(item.individual_traits);
  }
  return text.trim();
};

// 창체 단일 입력은 이름을 알리려 맨 앞에 "[학생] 이름" 줄을 둔다. 다중은 이름을 따로 넘기므로 뺀다.
const STUDENT_HEADER_LINE = /^\[학생\][^\n]*\n*/;

const toBatchStudents = (students = []) => (Array.isArray(students) ? students : [])
  .map((student, index) => {
    const text = buildFileStudentText(student).replace(STUDENT_HEADER_LINE, '').trim();
    return {
      id: String(student?.id || `file_student_${index + 1}`),
      name: String(student?.name || '').trim() || `학생 ${index + 1}`,
      content: text,
      existing_content: text,
      ...(student?.confidence ? { confidence: student.confidence } : {}),
    };
  })
  .filter((student) => student.content);

export const countBatchableFileStudents = (category, students) => (
  MULTI_STUDENT_BATCH_CATEGORIES.includes(category) ? toBatchStudents(students).length : 0
);

export const canMakeFileStudentsAtOnce = (category, students) => (
  countBatchableFileStudents(category, students) >= 2
);

export const buildBatchStateFromFileStudents = ({ category, students, wordCount }) => {
  const batchStudents = toBatchStudents(students);
  return {
    source: 'single_file',
    category,
    ...(wordCount ? { wordCount } : {}),
    students: batchStudents,
    sourceFileName: '단일 생성에서 올린 파일',
    sourceFileMeta: {
      source: 'single_file',
      detected_students: batchStudents.length,
      analysis_method: 'single_generation_file',
    },
  };
};
